import { useRef, useState } from 'react';
import css from './StoreSlider.module.scss';
import SingleButton from '../../../../widgets/form/form-control-buttons/SingleButton/SingleButton';
import T from '../../../../common/components/T';
import { navigateV2 } from '../../../../common/utils/router';
import parse from 'html-react-parser';
import Slider from 'react-slick';
import { svgSprite } from '../../../../hybrid/wrappers';
import classNames from 'classnames';
import Image from 'next/image';

const ProductItem = ({ banner }) => {
    return (
        <div className={css.sliderItem}>
            <Image fill src='/src/img/store/store_slider_circle.png' alt='Slider circle' />
            <Image fill src={banner.image?.links?.preview} className={css.sliderItemImage} />
        </div>
    );
};

export default function StoreSlider({ banners = [] }) {
    const [currentProduct, setCurrentProduct] = useState(banners?.[0]);
    const ref = useRef();
    const [slideIndex, setSlideIndex] = useState(0);

    const sliderSettings = {
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        className: css.slider,
        arrows: false,
        swipe: false,
        autoplay: true,
        autoplaySpeed: 5000,
        ref,
        beforeChange: (current, next) => {
            setSlideIndex(next);
            setCurrentProduct(banners[next]);
        }
    };
    if (banners?.length === 0) return null;
    return (
        <div className={css.wrapper}>
            <div className={css.productInfo}>
                <p className={css.productTitle}>{currentProduct?.title}</p>
                {currentProduct?.description ? (
                    <div className={css.productDescription}>
                        <div className={css.productDescriptionLine}></div>
                        <p className={css.productDescriptionText}>{parse(currentProduct?.description)}</p>
                    </div>
                ) : null}
                <div className={css.productInfoBottom}>
                    <SingleButton
                        type='ok'
                        buttonText={<T textName='more' defaultStr='Подробнее' />}
                        clickFunc={() => {
                            const url = new URL(currentProduct?.link);
                            const domain = 'globaltrendcompany';
                            if (url.host.includes(domain)) {
                                navigateV2(url.pathname);
                            } else {
                                window.open(url.href, '_self');
                            }
                        }}
                        customButton={{
                            butWrapper: css.productMoreButton,
                            singleButton: css.productMoreButtonWrapper
                        }}
                    />
                    <div className={css.productSliderSettings}>
                        <p className={css.productSliderCurrentSlide}>
                            {slideIndex + 1 > 9 ? slideIndex + 1 : `0${slideIndex + 1}`}
                        </p>
                        <div className={css.productSliderCountSeparator}>/</div>
                        <div className={css.productSliderSlidesNumber}>
                            {banners.length > 9 ? banners.length : `0${banners.length}`}
                        </div>
                        <div className={css.sliderFillLine}>
                            <div
                                className={classNames(
                                    css.sliderFillLineFill,
                                    css[`lineFill${slideIndex + 1}-${banners?.length}`]
                                )}
                            ></div>
                        </div>
                        <div className={css.sliderButtons}>
                            <div onClick={() => ref?.current?.slickPrev()} className={css.sliderButton}>
                                {svgSprite('arrow-left-gt-store')}
                            </div>
                            <div onClick={() => ref?.current?.slickNext()} className={css.sliderButton}>
                                {svgSprite('arrow-right-gt-store')}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={css.productSlider}>
                <Slider {...sliderSettings}>
                    {banners.map((banner) => (
                        <ProductItem banner={banner} key={banner?.id} />
                    ))}
                </Slider>
                <div className={classNames(css.productSliderSettingsMobile)}>
                    <div onClick={() => ref?.current?.slickPrev()} className={css.sliderButton}>
                        {svgSprite('arrow-left-gt-store')}
                    </div>
                    <p className={css.productSliderCurrentSlide}>{`0${slideIndex + 1}`}</p>
                    <div className={css.productSliderCountSeparator}>/</div>
                    <div className={css.productSliderSlidesNumber}>{`0${banners.length}`}</div>
                    <div onClick={() => ref?.current?.slickNext()} className={css.sliderButton}>
                        {svgSprite('arrow-right-gt-store')}
                    </div>
                </div>
            </div>
        </div>
    );
}
